import React from "react";
import styles from "./TermsAndConditions.module.css";

const TermsAndConditions = () => {
  return (
    <div className={styles.termsContainer}>
      <h1 className={styles.title}>Sageion.com Terms and Conditions</h1>
      <p className={styles.subtitle}>
        Last Revised: October 13, 2025. Please read these terms carefully before using Sageion.com.
      </p>

      {/* 1. Acceptance of Terms */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>1. Acceptance of Terms</h2>
        <p className={styles.text}>
          By using Sageion.com, you agree to be bound by these Terms and Conditions.
          If you are using the Services on behalf of an organization, you confirm that you have the authority to bind such organization.
        </p>
      </section>

      {/* 2. Nature of Service */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>2. Nature of Service</h2>
        <p className={styles.text}>
          Sageion.com provides access to certain information and content, including data, text, photos, videos, user interfaces, logos, designs, or other materials.
          You are granted a limited, non-exclusive, revocable, non-transferable right to use the Services for personal or commercial purposes. All rights not expressly granted are reserved.
        </p>
        <p className={styles.text}>
          <strong>Third-Party Users:</strong> You are responsible for all acts and omissions of any third-party users you allow to access the Services.
          <strong>Beta Features:</strong> Some features may be experimental or in beta and may change or be discontinued at any time. We are not liable for issues arising from Beta Features.
        </p>
      </section>

      {/* 3. Registration & Account Security */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>3. Registration & Account Security</h2>
        <p className={styles.text}>
          You may need to provide personal and organizational information and maintain credentials.
          You are responsible for all activity under your account and for keeping your credentials secure.
        </p>
      </section>

      {/* 4. Sageion.com Technology & Feedback */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>4. Sageion.com Technology & Feedback</h2>
        <p className={styles.text}>
          All intellectual property, including software, designs, logos, and trademarks, remains the property of Sageion.com.
          You are granted a limited license to use the Services as provided.
          Any feedback you provide may be used by Sageion.com worldwide, irrevocably, and royalty-free.
        </p>
      </section>

      {/* 5. Third-Party Services */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>5. Third-Party Services</h2>
        <p className={styles.text}>
          Sageion.com may interact with third-party services. We are not responsible for any third-party acts, omissions, or failures.
          Your use of such services may require acceptance of additional terms.
        </p>
      </section>

      {/* 6. Disclaimers & Limitation of Liability */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>6. Disclaimers & Limitation of Liability</h2>
        <p className={styles.text}>
          The Services are provided "as-is". Sageion.com disclaims all warranties, express or implied.
          To the maximum extent permitted by law, we shall not be liable for indirect, incidental, or consequential damages.
          Our total liability is limited to the fees paid by you in the last 12 months.
        </p>
      </section>

      {/* 7. Indemnity, Termination & Suspension */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>7. Indemnity, Termination & Suspension</h2>
        <p className={styles.text}>
          You agree to indemnify Sageion.com for claims arising from your breach of this Agreement or use of the Services.
          We may suspend or terminate your access for violations or breaches.
          If terminated for convenience, prepaid fees may be refunded on a pro-rata basis.
        </p>
      </section>

      {/* 8. Governing Law & Disputes */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>8. Governing Law & Disputes</h2>
        <p className={styles.text}>
          These Terms are governed by Indian law. Any disputes shall be resolved in courts located in Delhi NCR, India.
        </p>
      </section>

      {/* 9. Miscellaneous */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>9. Miscellaneous</h2>
        <ul className={styles.list}>
          <li className={styles.listItem}>Waiver: No waiver is effective unless in writing.</li>
          <li className={styles.listItem}>Entire Agreement: These Terms supersede prior agreements.</li>
          <li className={styles.listItem}>Assignment: You cannot transfer rights without prior written consent.</li>
          <li className={styles.listItem}>Relationship: Parties are independent contractors.</li>
          <li className={styles.listItem}>Severability: Invalid provisions do not affect others.</li>
          <li className={styles.listItem}>Notice: Email to your registered address is considered formal notice.</li>
          <li className={styles.listItem}>Publicity: Sageion.com may use your name and logo in marketing materials.</li>
        </ul>
      </section>

      <footer className={styles.footer}>
        <p className={styles.footerText}>
          Last updated: October 13, 2025. For inquiries, contact us at <a href="mailto:support@sageion.com">support@sageion.com</a>.
        </p>
      </footer>
    </div>
  );
};

export default TermsAndConditions;
